import { render, staticRenderFns } from "./cpt-carousel.vue?vue&type=template&id=11958e77&scoped=true"
import script from "./cpt-carousel.vue?vue&type=script&lang=js"
export * from "./cpt-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11958e77",
  null
  
)

export default component.exports